import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import registerServiceWorker from "./registerServiceWorker";

import "./assets/styles/base.scss";

import Main from "./pages/Main";

ReactDOM.render(
  <Router>
    <Main />
  </Router>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js